import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSparkline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={81}
    height={43}
    fill="none"
    viewBox="0 0 81 43"
    {...props}
  >
    <path
      stroke="url(#a)"
      strokeWidth={2}
      d="m1.5 42 10.199-31.38c1.074-3.306 5.563-3.763 7.281-.741l6.366 11.196c1.571 2.762 5.581 2.678 7.035-.148l4.238-8.242a4 4 0 0 1 4.342-2.093l9.842 1.969a4 4 0 0 0 3.72-1.205l7.747-8.367a4 4 0 0 1 6.115.29L80 18.5"
    />
    <defs>
      <linearGradient
        id="a"
        x1={1}
        x2={80}
        y1={-0.5}
        y2={-0.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE0CC" />
        <stop offset={1} stopColor="#EF8C61" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgSparkline;
